import classes from './TimeBarPoint.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { GAMEMODE } from '../../utils/constants';
import useVideoQuizConfig from '../../hooks/useVideoQuizConfig';
import { NAME_SOUND_ACTIVE, NAME_SOUND_HOVER, useGameSounds } from '@educaplay/core';

function TimeBarPoint(props) {
    const { variant, className, active, onClick, done, pending, left, incorrect } = props;
    const { gameMode } = useVideoQuizConfig();
    const gameSound = useGameSounds();
    const isSequential = gameMode === GAMEMODE.SEQUENTIAL;
    const isFreedom = gameMode === GAMEMODE.FREEDOM;
    const dotClasses = clsx(classes.dot, {
        [classes.sequential]: gameMode === GAMEMODE.SEQUENTIAL,
        [classes.info]: variant === 'info',
        [classes.pending]: pending,
        [classes.done]: done,
        [classes.small]: (done || (pending && isSequential)) && ((!active && isSequential) || isFreedom && variant !== "info"),
        [classes.inactive]: isSequential || (isFreedom && (done || done && incorrect) && variant !== "info")  ,
        [classes.active]: active,
        [classes.incorrect]: done && incorrect,
    });

    return (
        <button
            type='button'
            disabled={active || gameMode === GAMEMODE.SEQUENTIAL}
            className={clsx(classes.slicepoint, className)}
            onClick={()=>{
                gameSound.play(NAME_SOUND_ACTIVE)
                onClick();
            }}
            onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)}
            style={{
                left: `${left}%`,
            }}>
            <div className={dotClasses} />
        </button>
    )
}

export default TimeBarPoint

TimeBarPoint.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'info']),
    active: PropTypes.bool,
    onClick: PropTypes.func,
    done: PropTypes.bool,
    pending: PropTypes.bool,
    left: PropTypes.number,
    incorrect: PropTypes.bool
}